import { initializerDefineProperty as _initializerDefineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { assertThisInitialized as _assertThisInitialized } from "\0rollupPluginModLoBabelHelpers.js";
import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { applyDecoratedDescriptor as _applyDecoratedDescriptor } from "\0rollupPluginModLoBabelHelpers.js";
import { initializerWarningHelper as _initializerWarningHelper } from "\0rollupPluginModLoBabelHelpers.js";

var _dec, _dec2, _dec3, _dec4, _dec5, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "42b7e/XX6RKxLjQkN1zcHpE", "Set", undefined);

import { _decorator, Component, Node, tween, v3, UITransform, Mask } from 'cc';
import { App } from './common/manager/App';
var ccclass = _decorator.ccclass,
    property = _decorator.property;
export var Set = (_dec = ccclass('Set'), _dec2 = property(Node), _dec3 = property(Node), _dec4 = property(Node), _dec5 = property(Node), _dec(_class = (_class2 = (_temp = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Set, _Component);

  function Set() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _initializerDefineProperty(_assertThisInitialized(_this), "n_mask", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_content", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_v", _descriptor3, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_s", _descriptor4, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "_isEOpen", false);

    _defineProperty(_assertThisInitialized(_this), "_isVOpen", false);

    return _this;
  }

  var _proto = Set.prototype;

  _proto.onLoad = function onLoad() {
    this.node.getComponent(Mask);
  };

  _proto.start = function start() {
    App.GameCtrl.addBtnEvent(this.node, this.btn_event.bind(this));
    this._isEOpen = App.SoundMgr.musicState;

    if (App.GameCtrl.checkShake()) {
      this._isVOpen = App.LocalDBMgr.shakeState;
      this.n_v.active = true;
    } else {
      this.n_v.active = false;
    }

    this.updateState_s();
    this.updateState_v();
  };

  _proto.updateState_s = function updateState_s() {
    this.n_s.children[0].active = !this._isEOpen;
    this.n_s.children[1].active = this._isEOpen;
    App.SoundMgr.musicState = this._isEOpen;
    App.SoundMgr.effectState = this._isEOpen;
  };

  _proto.updateState_v = function updateState_v() {
    this.n_v.children[0].active = !this._isVOpen;
    this.n_v.children[1].active = this._isVOpen;
    App.LocalDBMgr.shakeState = this._isVOpen;
  };

  _proto.btn_event = function btn_event(btn) {
    var name = "";
    if (btn.node) name = btn.node.name;
    if (btn.target) name = btn.target.name;

    switch (name) {
      case "n_set":
        if (this.n_content.position.y == 0) {
          this.exit();
        } else {
          this.enter();
        }

        break;

      case "n_s":
        this._isEOpen = !this._isEOpen;
        this.updateState_s();
        break;

      case "n_v":
        this._isVOpen = !this._isVOpen;
        this.updateState_v();
        break;
    }
  };

  _proto.enter = function enter() {
    var _this2 = this;

    if (App.GameCtrl.isSwitch) return;
    App.GameCtrl.isSwitch = true;
    this.n_mask.active = true;
    tween(this.n_content).to(0.5, {
      position: v3(0, 0, 0)
    }, {
      easing: "sineInOut"
    }).call(function () {
      _this2.n_mask.getComponent(Mask).enabled = false;
      App.GameCtrl.isSwitch = false;
    }).start();
  };

  _proto.exit = function exit() {
    var _this3 = this;

    if (App.GameCtrl.isSwitch) return;
    App.GameCtrl.isSwitch = true;
    this.n_mask.getComponent(Mask).enabled = true;
    tween(this.n_content).to(0.5, {
      position: v3(0, this.n_content.getComponent(UITransform).contentSize.height, 0)
    }, {
      easing: "sineInOut"
    }).call(function () {
      _this3.n_mask.active = false;
      App.GameCtrl.isSwitch = false;
    }).start();
  };

  return Set;
}(Component), _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "n_mask", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "n_content", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "n_v", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "n_s", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
})), _class2)) || _class);
/**
 * [1] Class member could be defined like this.
 * [2] Use `property` decorator if your want the member to be serializable.
 * [3] Your initialization goes here.
 * [4] Your update function goes here.
 *
 * Learn more about scripting: https://docs.cocos.com/creator/3.0/manual/en/scripting/
 * Learn more about CCClass: https://docs.cocos.com/creator/3.0/manual/en/scripting/ccclass.html
 * Learn more about life-cycle callbacks: https://docs.cocos.com/creator/3.0/manual/en/scripting/life-cycle-callbacks.html
 */

_cclegacy._RF.pop();